import React from 'react';

const ErrorFallback = ({ onRetry, onGoHome }) => (
  <main className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-6">
    <section className="w-full max-w-xl rounded-xl border border-amber-500/20 bg-zinc-900 p-6">
      <h1 className="text-xl font-semibold text-amber-400">
        Unexpected Application Error
      </h1>
      <p className="mt-3 text-zinc-400 text-sm">
        The frontend hit an unexpected error. You can retry this screen or return
        to the application root.
      </p>
      <div className="mt-6 flex gap-3">
        <button
          type="button"
          onClick={onRetry}
          className="rounded-lg bg-indigo-600 hover:bg-indigo-500 px-4 py-2 text-sm font-semibold text-white transition-colors"
        >
          Retry
        </button>
        <button
          type="button"
          onClick={onGoHome}
          className="rounded-lg border border-zinc-700 hover:border-zinc-600 px-4 py-2 text-sm font-semibold text-zinc-300 hover:text-zinc-100 transition-colors"
        >
          Go Home
        </button>
      </div>
    </section>
  </main>
);

export default ErrorFallback;
